export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '亚洲天堂提供哪些服务？',
    answer: '亚洲天堂是一个专注于亚洲旅游目的地的综合资讯平台。我们提供最全面、最新鲜的亚洲旅游攻略、目的地指南、美食推荐、酒店评测以及实用的旅行贴士，帮助每一位旅行者打造完美的亚洲之旅。',
  },
  {
    question: '如何选择适合我的亚洲旅行目的地？',
    answer: '您可以根据自己的旅行偏好来选择：如果喜欢海岛度假，推荐巴厘岛、马尔代夫或普吉岛；如果热爱历史文化，京都、吴哥窟和加德满都不可错过；如果追求都市繁华与美食体验，东京、首尔和曼谷是最佳选择。我们的分类页面也可以帮您按东南亚、东亚和南亚三大区域快速筛选目的地。',
  },
  {
    question: '亚洲旅行最佳季节是什么时候？',
    answer: '亚洲地域辽阔，不同区域的最佳旅行季节各有不同。东南亚最佳时间为11月至次年2月（旱季凉爽）；东亚春秋两季（3月-5月、9月-11月）气候最宜人；南亚的旺季为10月至次年3月。建议在出行前查看具体目的地的最佳旅行月份。',
  },
  {
    question: '亚洲天堂的内容是否可靠？',
    answer: '我们的所有内容均由资深旅行作者实地探访后撰写，部分文章还邀请了当地达人参与创作。每篇文章都会标注作者信息和更新日期，确保信息的准确性和时效性。我们承诺为读者提供真实、客观、实用的旅行参考。',
  },
  {
    question: '如何联系亚洲天堂进行商务合作？',
    answer: '您可以通过我们网站"关于我们"页面的联系表单提交合作意向，或直接发送邮件至我们的商务合作邮箱。我们的团队会在2个工作日内回复您的咨询。欢迎酒店、旅游局、旅行品牌等合作伙伴与我们联系。',
  },
  {
    question: '亚洲天堂有APP吗？',
    answer: '目前我们优先专注于网站内容的优化和更新，为用户提供最佳的网页浏览体验。移动端APP正在规划中，敬请期待。您可以将我们的网站添加到手机主屏幕，即可获得类似APP的使用体验。',
  },
];